// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_ITEM_CATEGORIES: `${environment.apiUrl}/meta/item-categories`,
  GET_STORE_CATEGORIES: `${environment.apiUrl}/meta/online-store-categories`,
  GET_COURIERS: `${environment.apiUrl}/meta/couriers/:country`,
  GET_COUNTRIES: `${environment.apiUrl}/geography/countries`,
  GET_ONLINE_STORES: `${environment.apiUrl}/meta/store/10`,
});

export const getItemCategoriesApi = getCreator(fetch, endpoints.GET_ITEM_CATEGORIES);
export const getStoreCategoriesApi = getCreator(fetch, endpoints.GET_STORE_CATEGORIES);
export const getCouriersApi = getCreator(fetch, endpoints.GET_COURIERS);
export const getCountriesApi = getCreator(fetch, endpoints.GET_COUNTRIES);
export const getOnlineStores = getCreator(fetch, endpoints.GET_ONLINE_STORES);



// WEBPACK FOOTER //
// ./src/modules/local-values/api.js